<app-breadcrumb *ngIf="!krk && !dialogRef" [master]="'Rejestracje'" [parentName]="'KRK'" [name]="'Dodaj'"></app-breadcrumb>
<div class="krk-add" fxLayout="column" fxLayoutGap="15px"  >
  <div class="status-info" *ngIf="krk">
    <app-dict
      [label]="'Status'" [dictType]="'krk_status'"
      [control]="statusControl"
      [required]="true"
      [multiple]="false"
      appearance="fill"
      [color]="true"
    ></app-dict>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="!dialogRef">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!krkForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div [fxFlex]="dialogRef ? '100' : '50'" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane KRK</h3>
        </div>

        <div fxLayout="row">
          <app-dict fxFlex="100" dictType="krk_payer" label="Kto ponosi opłatę"
                    [required]="true" [control]="payerControl" ></app-dict>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="krk">
          <app-datepicker fxFlex="50"
            label="Data wyrobienia"
            placeholder="2000-01-01"
            [required]="false"
            [control]="activeFromControl"
          ></app-datepicker>

          <app-datepicker fxFlex="50"
                          label="Data ważności"
                          placeholder="2000-01-01"
                          [required]="false"
                          [control]="activeToControl"
          ></app-datepicker>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="krk">
          <div fxFlex="50">
            <mat-slide-toggle [formControl]="activeFeeControl" color="accent">Aktywna opłata</mat-slide-toggle>
          </div>
        </div>

      </mat-card>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column" *ngIf="!dialogRef">
      <mat-card>
        <div fxLayout="row">
          <h3>Relacje</h3>
        </div>

        <div fxLayout="row">
          <app-dict-ofwcas fxFlex="100" label="OFWCA" [control]="ofwcaControl" [required]="true"></app-dict-ofwcas>
        </div>

      </mat-card>

    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!krkForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
